<template>
  <el-form ref="ruleForm" :model="form" :rules="rules">
    <el-form-item label="旧密码" prop="oldPassword">
      <el-input v-model.trim="form.oldPassword" type="password" autocomplete="off" />
    </el-form-item>
    <el-form-item label="新密码" prop="newPassword">
      <el-input v-model.trim="form.newPassword" type="password" autocomplete="off" />
    </el-form-item>
    <el-form-item label="确认密码" prop="confirmPassword">
      <el-input v-model.trim="form.confirmPassword" type="password" autocomplete="off" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import api from '@/api/account'
export default {
  props: {
    user: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      form: {
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 8, message: '长度至少为 8 个字符', trigger: 'blur' },
          { pattern: /[A-Z]/, message: '密码必须包含至少一个大写字母', trigger: 'blur' },
          { pattern: /[a-z]/, message: '密码必须包含至少一个小写字母', trigger: 'blur' },
          { pattern: /[0-9]/, message: '密码必须包含至少一个数字', trigger: 'blur' },
          { pattern: /[!@#$%^&*(),.?":{}|<>]/, message: '密码必须包含至少一个特殊字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          api.ChangePassword(this.form).then(response => {
            this.$message({
              message: response.msg,
              type: 'success'
            })
            if (response.code === 200) {
              this.$alert('修改密码成功请您重新登录', '系统提示', {
                confirmButtonText: '确定',
                showClose: false,
                callback: action => {
                  this.logout()
                }
              })
            }
            this.$refs.ruleForm.resetFields()
          })
        }
      })
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.path}`)
    }
  }
}
</script>
